import ProductRecord from '@components/containers/catalog/ProductRecord';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const CatalogProduct: FC = () => (
    <AppLayout>
        <ProductRecord />
    </AppLayout>
);

export default CatalogProduct;
